import $ from 'jquery';
import 'magnific-popup';
import 'parsleyjs';
import '../Language/magnific-popup'

(function () {
    const $lightbox = $('a.lightbox');
    if ($lightbox.length === 0) {
        return;
    }

    $lightbox.magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        zoom: {
            enabled: true,
            easing: 'ease-in-out'
        }
    });
})();

(function () {
    const $inlineLightboxes = $('a.ajax-lightbox');
    if ($inlineLightboxes.length === 0) {
        return;
    }

    $inlineLightboxes.magnificPopup({
        type: 'ajax',
        callbacks: {
            parseAjax: function (mfpResponse) {
                mfpResponse.data = $(mfpResponse.data).addClass('white-popup');
                mfpResponse.data.find('form').parsley();
            },
            ajaxContentAdded: function () {
                const $link = $(this.ev);
                if ($link.attr('data-fill-target') && $link.attr('data-fill-value')) {
                    const targetStr = $link.attr('data-fill-target');
                    const valueStr = $link.attr('data-fill-value');
                    try {
                        $(this.content).find(targetStr).val(valueStr);
                    } catch (e) {
                        console.warn('Could not fill target', targetStr, 'with value', valueStr);
                        console.warn(e);
                    }
                }
            }
        }
    });
})();
